// -*- coding: utf-8 -*-
// Generated by scripts/generate_from_specs.py
// Modalities

export default {
    CUSTOM_NAVIGATION: "CUSTOM_NAVIGATION",
    QUIZ: "QUIZ",
    SURVEY: "SURVEY",
};
